import { useDataLinking } from 'global/cnr/contexts/useHelpers/useDataLinking'
import MiniSwipe from 'global/components/swipers/MiniSwipe'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { Icon, Menu } from 'semantic-ui-react'
import { uniqueKey } from '../../common/keys'
import FullPageWrapper from '../../wrappers/FullPageWrapper'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import DataLinkingMenus from './DataLinkingMenus'
import { convertHelpers } from 'global/common/convert'

const DataLinkingSidebar = () => {

  const dataLinking = useDataLinking()

  const {
    data_page: currentPageData,
    view_page: framewordRightView,
    view_right: pageRightDataCollection,
    viewItem_right: pageRightViewItem,
    viewKey_page: pageItemKey,
    viewItem_page: viewItem,
    view_page: modifyViewItemKey,
    docProps,
    dataLinkProps,
  } = dataLinking ?? {}


  const dataName = convertHelpers.getItemName(currentPageData)

  const { key: key_view } = viewItem ?? {}

  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentParentItemData, setCurrentParentItemData] = useState()

  useEffect(() => {
    setCurrentParentItemData(_.cloneDeep(currentPageData));
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentPageData, pageRightDataCollection, pageRightViewItem]);

  // updates when dataLinkProps.linkCollection changes
  useEffect(() => {
    if (currentParentItemData && dataLinkProps.linkCollection) {
      setCurrentIndex(1)
    } else {
      setCurrentIndex(0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [dataLinkProps.linkCollection]);

  const handleChangeIndex = (index) => { setCurrentIndex(index > 1 ? 1 : 0) }

  const handleSelect_docProp = (key) => {
    const _dataLinkProps = { ...dataLinkProps }
    _dataLinkProps.linkCollection = key === dataLinkProps.linkCollection ? null : key
    setDataLinkProps(_dataLinkProps)
  }

  const menu_linkItems = () => {
    const cn = 'menu-ids dls'
    if (docProps) {
      const _items = _.map(docProps, (value, key) => {
        const _selected = dataLinkProps.linkCollection === key
        const icon = _selected ? 'arrow down' : 'arrow right'
        return <Menu.Item key={uniqueKey('dls', key)} onClick={() => { handleSelect_docProp(value) }}>
          <div>
            <div>{_.startCase(value)}</div>
            <div><Icon name={icon}></Icon></div>
          </div>
        </Menu.Item>
      })
      return <Menu vertical fluid className={cn}>
        {_items}
      </Menu>
    }
  }

  const wrapper_content = () => <Wrapper
    header={_.startCase(framewordRightView) + ' (#' + pageItemKey + ') Links'}
    content={menu_linkItems()}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
  />

  const dlm = () => <DataLinkingMenus dataLinking={dataLinking} />
  const dlmw = () => <Wrapper
    header={_.startCase(dataLinkProps?.linkCollection)}
    content={dlm()}
    wrapperType={wrapperTypes.paddedHeader}
  ></Wrapper>

  const content_swipeable = () => <MiniSwipe
    swipeItems={[wrapper_content(), dlm()]}
    handleIndexChange={handleChangeIndex}
    currentIndex={currentIndex}
  />

  const fpw = () => <FullPageWrapper
    topperCaption={`${_.startCase(key_view)} (${dataName})`}
    content={modifyViewItemKey ? dlmw() : content_swipeable()}
    css={{ container: 'app-dark-mode' }}
  ></FullPageWrapper>

  return fpw()
}

export default DataLinkingSidebar
